/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxTreeViewModule, DxDataGridModule, DxTagBoxModule } from 'devextreme-angular';
import { DxoColumnFixingModule, DxoGroupPanelModule, DxoEditingModule, DxoPopupModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { User } from './models/user';
import { UserGroup } from './models/user-group';
import { UserService } from './services/user.service';
import { UserGroupService } from './services/user-group.service';
import { CurrentUserService } from './services/current-user.service';
import { GenericModalService, ModalSettingsInput, ModalSettingsMessage, ModalSettingsTemplate } from '../shared/generic-modal/generic-modal.service';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { Partner } from '../partner/models/partner';
import { PartnerService } from '../partner/services/partner.service';
import { PersonalAccessToken } from './models/personal-access-token';
import { UserPATService } from './services/user-pat.service';
import { IdentityScope } from '../identity/models/identity-scope';
import { IdentityService } from '../identity/services/identity.service';
import { DateTimeService } from '../shared/datetime/datetime.service';
import { ConfigurationService } from '../configuration/services/configuration.service';
import { PartnerSelectorComponent } from '../partner/partner-selector.component';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../shared/change-log/change-log-link-entity/change-log-link-entity.directive';

@Component({
    templateUrl: './user-profile.component.html',
    selector: 'ep-user-profile',
    styleUrls: ['./user-profile.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, NgClass, PartnerSelectorComponent, DxTreeViewModule, DxDataGridModule, BizDataGridDirective, DxoColumnFixingModule, DxoGroupPanelModule, DxoEditingModule, DxoPopupModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule, DxTemplateModule, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxTagBoxModule]
})
export class UserProfileComponent implements OnInit, OnChanges {
    @ViewChild('changePasswordTemplate', { static: true }) passwordTemplate: TemplateRef<any>;
    @ViewChild('userAccessDetailsTemplate', { static: true }) userAccessDetailsTemplate: TemplateRef<any>;
    @ViewChild('enableMfaTemplate', { static: true }) enableMfaTemplate: TemplateRef<any>;
    @ViewChild('disableMfaTemplate', { static: true }) disableMfaTemplate: TemplateRef<any>;
    @ViewChild('regenerateSecretTemplate', { static: true }) regenerateSecretTemplate: TemplateRef<any>;

    @Input() loadCurrentUser = false;
    @Input() currentUser: User;
    @Output() userSaved: EventEmitter<UserSavedArgs> = new EventEmitter<UserSavedArgs>();
    @Output() editChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() cancelPressed: EventEmitter<void> = new EventEmitter<void>();

    public clonedUser: User;
    public isEditable = false;
    public isBuiltIn = false;
    public isMfaEnabled = false;
    public newUser = false;

    public editAllowed = false;
    public editUserGroupsAllowed = false;
    public showUserAccessOverviewAllowed = false;
    public showPersonalAccessTokensAllowed = false;
    public changeUsernameAllowed = false;
    public changePasswordAllowed = false;
    public setMfaAllowed = false;

    public allowUpdatingPAT = false;
    public allowAddingPAT = false;
    public allowDeletingPAT = false;
    public allowShowLogPAT = true;
    public allowShowManageMfa = true;

    public defaultPartner: Partner = null;
    public noAccessToDefaultPartner = false;
    public userGroups: UserGroup[];
    public userPats: PersonalAccessToken[] = [];
    public apiScopes: IdentityScope[] = [];

    public isAdAuthentication = false;

    public passwordDraft1 = '';
    public passwordDraft2 = '';

    constructor(
        private userService: UserService,
        private userGroupService: UserGroupService,
        private partnerService: PartnerService,
        private modalService: GenericModalService,
        private loadingPanelService: LoadingPanelService,
        private currentUserService: CurrentUserService,
        private userPATService: UserPATService,
        private identityService: IdentityService,
        public dateTimeService: DateTimeService,
        private configurationService: ConfigurationService) { }

    ngOnInit(): void {
        if (this.loadCurrentUser) {
            this.userService.getCurrentUser().then(user => {
                this.currentUser = { ...user };
                this.init();
            });
        }
        else {
            this.currentUser = new User();
        }
    }

    ngOnChanges(change: any) {
        if (change.currentUser && this.currentUser) {
            this.init();
        }
    }

    initPermissions() {
        this.editAllowed = (this.currentUserService.hasPermission('User_Action_UserEdit') || this.loadCurrentUser) && !this.currentUser.IsDisabled; // Current user can always edit own profile
        this.changeUsernameAllowed = this.currentUserService.hasPermission('User_Action_ChangeUsername');
        this.changePasswordAllowed = this.currentUserService.hasPermission('User_Action_ChangePassword') || this.loadCurrentUser; // Current user can always change own password
        this.showUserAccessOverviewAllowed = this.currentUserService.hasPermission('User_Action_ViewUserAccessOverview');
        this.showPersonalAccessTokensAllowed = this.currentUserService.hasPermission('Identity_View');
        this.setMfaAllowed = this.currentUserService.hasPermission('User_Action_SetMFASecret') || this.loadCurrentUser; // Current user can always manage MFA
        this.isBuiltIn = this.currentUser.IsBuiltIn;
        this.isAdAuthentication = !!this.currentUser?.Credentials?.DomainAccountName?.startsWith('oid');

        // TODO: FIX permissions
        this.allowAddingPAT = this.currentUserService.hasPermission('User_Action_PAT_Create');
        this.allowDeletingPAT = this.currentUserService.hasPermission('User_Action_PAT_Edit');
        this.allowUpdatingPAT = this.currentUserService.hasPermission('User_Action_PAT_Delete');
        this.allowShowLogPAT = this.currentUserService.hasPermission('User_Action_PAT_ShowLog');

        if (this.isBuiltIn) {
            this.changeUsernameAllowed = false;
            this.editAllowed = false;
            if (!this.currentUserService.hasPermission('System_User_Admin')) {
                this.changePasswordAllowed = false;
            }
        }

        if (this.userGroups) {
            this.userGroups.forEach(ug => {
                const editable = this.currentUserService.hasPermission('User_Action_UserEditUserGroups');
                ug['isEditable'] = editable;
            });
        }
    }

    async init() {
        void this.showManageMfa();
        this.setEdit(false);
        this.clonedUser = Object.assign({}, this.currentUser);
        this.newUser = !this.clonedUser.UserId;

        const promises = [];
        promises.push(this.findGroups());
        promises.push(this.findDefaultPartner());

        if (!this.newUser) {
            promises.push(this.userPATService.getTokensForUser(this.clonedUser.UserId).then(r => {
                this.userPats = r;
                if (this.userPats) {
                    this.userPats.forEach(up => {
                        up['ScopesInternal'] = up.Scopes.split(' ').filter(e => e.length);
                    });
                }
            }));
        }

        this.loadingPanelService.showLoadingPanelDirect('Loading user details...');

        await Promise.all(promises);

        this.initPermissions();

        if (this.showPersonalAccessTokensAllowed) {
            this.apiScopes = await this.identityService.getScopes();
        }

        this.loadingPanelService.hideLoadingPanel();
        if (!this.clonedUser.UserId) { // If it's a new user - go directly to edit-mode
            this.edit();
        }

        if (!this.newUser) {
            void this.userService.isMfaEnabled(this.clonedUser.UserId).then((result: boolean) => this.isMfaEnabled = result);
        }
    }

    /* Personal Access Tokens */

    onInitNewRowPAT(ev: any) {
        ev.data = {
            Id: null,
            Name: '',
            Scopes: 'api',
            UserId: this.clonedUser.UserId
        } as PersonalAccessToken;
        ev.data.ScopesInternal = ['api'];
    }

    async onRowInsertedPAT(ev: any): Promise<void> {
        const token: PersonalAccessToken = ev.data;
        token.Scopes = (<string[]>ev.data.ScopesInternal).join(' ');
        const createPatResult = await this.userPATService.createToken(token);
        Object.assign(ev.data, createPatResult.Entity);
        this.modalService.messageDirect('New Personal Access Token Created', 'You have successfully added a new personal access token. Copy the token now!<br /><pre>' + createPatResult.Token + '</pre><br /><label class=\'label label-warning\'>Warning - Make sure you copy the above token now. We don\'t store it and you will not be able to see it again.</label>').then(() => { }).catch(() => { });
    }

    async onRowUpdatedPAT(ev: any): Promise<void> {
        const token: PersonalAccessToken = ev.data;
        token.Scopes = (<string[]>ev.data.ScopesInternal).join(' ');
        Object.assign(ev.data, await this.userPATService.updateToken(token));
    }

    async onRowRemovingPAT(ev: any): Promise<void> {
        const token: PersonalAccessToken = ev.data;
        await this.userPATService.deleteToken(token.Id);
    }

    onScopeValueChanged(ev: any, cell: any) {
        cell.setValue(ev.value);
    }

    findGroups(): Promise<any> {
        return this.userGroupService.getUserGroups()
            .then(userGroups => {
                this.userGroups = userGroups.filter(g => !g.IsStakeholder).sort((g1, g2) => g1.Name.localeCompare(g2.Name)); // Only get non-stakeholder-groups
                // "Check" the usergroups for the current user
                for (const group of this.userGroups) {
                    group['selected'] = this.clonedUser.UserGroups.some(g => g.Id === group.Id);
                }
            })
            .catch(() => { });
    }

    getScopesFilterData: () => {text: any, value: any}[] = () =>
        // Ensure userPats are defined; use an empty array if undefined
        (this.userPats ?? []).flatMap(e => {
                const scopes = e.Scopes.split(' ').filter(e => e.length);
                return scopes.length > 0 ? scopes : ['(Blanks)'];
            }) // Flatten the scope values for all pats, or add '(Blanks)' if no scopes
            .filter((e, index, array) => array.indexOf(e) === index) // Remove duplicates
            .sort((a,b) => a.localeCompare(b))// Sort the scopes alphabetically
            .map(e => ({ text: e, value: e }));

    calculateScopesFilterExpression(filterValue: string) {
        return (row: PersonalAccessToken) => (filterValue == '(Blanks)')
            ? !(row.Scopes?.length > 0)
            : row.Scopes?.split(' ').includes(filterValue);
    }

    findDefaultPartner(): Promise<any> {
        return new Promise<void>((resolve) => {
            if (this.clonedUser.PartnerId) {
                this.partnerService.checkPartnerAccess([this.clonedUser.PartnerId]).then(hasAccess => {
                    if (hasAccess) {
                        this.partnerService.getLightPartner(this.clonedUser.PartnerId).then(lightPartner => {
                            this.defaultPartner = lightPartner;
                            this.noAccessToDefaultPartner = false;
                            resolve();
                        });
                    }
                    else {
                        this.noAccessToDefaultPartner = true;
                        resolve();
                    }
                });
            }
            else {
                this.defaultPartner = null;
                resolve();
            }
        });
    }

    changeUsername() {
        const settings = new ModalSettingsInput('Change username', 'New username');
        this.modalService.input(settings).then(
            (inputValue: string) => {
                if (typeof inputValue === 'undefined' || inputValue?.trim().length === 0) {
                    const settings = new ModalSettingsMessage('Username missing', 'Must enter a username');
                    this.modalService.message(settings).then((e) => { }).catch((e) => { });
                }
                else {
                    this.userService.isUsernameAvailable(this.clonedUser.UserId, inputValue).then((isAvailable: boolean) => {
                        if (isAvailable) {
                            this.userService.changeUsername(this.clonedUser.UserId, inputValue).then(() => {
                                this.currentUser.Credentials.UserName = inputValue;
                                const settings = new ModalSettingsMessage('Username changed', 'The username has now been changed');
                                this.modalService.message(settings).then((e) => { }).catch((e) => { });
                            });
                        }
                        else {
                            const settings = new ModalSettingsMessage('Username in use', 'The chosen username is not available');
                            this.modalService.message(settings).then((e) => { }).catch((e) => { });
                        }
                    });
                }
            })
            .catch(() => { });
    }

    async changePassword(): Promise<void> {
        try {
            // Reset BEFORE opening so stale values do not appear
            this.passwordDraft1 = '';
            this.passwordDraft2 = '';

            const password = await this.modalService.openTemplate(this.passwordTemplate, new ModalSettingsTemplate());
            if (typeof password === 'string' && password.length > 0) {
                this.clonedUser.Credentials.Password = password;
                await this.userService.setUserPassword(this.clonedUser);
                try {
                    await this.modalService.message(new ModalSettingsMessage('Password changed', 'The password has been changed'));
                }
                catch { /* ignore message dismiss */ }
            }
        }
        catch {
            // Modal dismissed (cancel/backdrop/esc) – ignore
        }
        finally {
            // Always clear AFTER close (success or cancel)
            this.passwordDraft1 = '';
            this.passwordDraft2 = '';
        }
    }

    cancel() {
        this.setEdit(false);
        this.init();
        this.cancelPressed.emit();
    }

    edit() {
        this.setEdit(true);
    }

    save(userProfileForm) {

        //while adding new user checking
        if (!this.clonedUser.UserId && userProfileForm.value.userName) {
            this.checkUserExistence(userProfileForm.value.userName);
        }
        else {
            this.saveUser();
        }
    }

    async saveUser(): Promise<void> {
        this.loadingPanelService.showLoadingPanelDirect('Saving user...');
        this.clonedUser.UserGroups = this.userGroups.filter(group => group['selected'] === true);
        const isNew = !this.clonedUser.UserId;
        const savedUser = await this.userService.saveUser(this.clonedUser);
        Object.assign(this.currentUser, savedUser);

        if (this.loadCurrentUser) {
            const user = await this.userService.getCurrentUser(true);
            this.currentUser = { ...user };
        }
        this.init();
        this.userSaved.emit(new UserSavedArgs(this.currentUser, isNew));
        this.loadingPanelService.hideLoadingPanel();
    }

    checkUserExistence(userName: string) {
        this.userService.isUsernameAvailable(null, userName).then((isAvailable: boolean) => {
            if (isAvailable) {//if user name available allow to save user
                this.saveUser();
            }
            else {
                const settings = new ModalSettingsMessage('Username in use', 'The chosen username is not available');
                this.modalService.message(settings).then((e) => { }).catch((e) => { });
            }
        });

    }
    setEdit(isEditable: boolean) {
        this.isEditable = isEditable;
        this.editChanged.emit(isEditable);
    }

    userAccessDetails: any[] = [];
    showAllPermissions() {
        const userGroupIds = this.currentUser.UserGroups.map(u => u.Id);
        if (userGroupIds.length > 0) {
            this.loadingPanelService.showLoadingPanelDirect('Loading user details...');
            this.userGroupService.getUserGroups(userGroupIds).then(userGroups => {
                const data: any[] = [];
                userGroups.forEach(g => {
                    const groupItem = {
                        id: g.Id,
                        text: `${g.Name} (UserGroup)`,
                        items: []
                    };
                    data.push(groupItem);

                    g.Roles.forEach(r => {
                        const roleItem = {
                            id: `${g.Id}_${r.RoleId}`,
                            text: `${r.RoleName} (Role)`,
                            items: []
                        };
                        groupItem.items.push(roleItem);

                        r.Permissions.forEach(p => {
                            const permissionItem = {
                                id: `${g.Id}_${r.RoleId}_${p.PermissionId}`,
                                text: `${p.PermissionName} (Permission)`
                            };
                            roleItem.items.push(permissionItem);
                        });
                    });
                });

                this.userAccessDetails = data;
                this.loadingPanelService.hideLoadingPanel();

                const settings = new ModalSettingsTemplate();
                this.modalService.openTemplate(this.userAccessDetailsTemplate, settings).then(() => { }).catch(() => { });
            });
        }
        else {
            this.modalService.messageDirect('No usergroups', 'The user is not in any usergroup').then(() => { }).catch(() => { });
        }
    }

    enableMFA() {
        const settings = new ModalSettingsTemplate();
        this.modalService.openTemplate(this.enableMfaTemplate, settings).then(() => {
            this.loadingPanelService.showLoadingPanelDirect('Enabling MFA...');
            this.userService.generateNewSecret(this.clonedUser.UserId).then(result => {
                this.loadingPanelService.hideLoadingPanel();
                const settings = new ModalSettingsMessage('Multi Factor Authentication', 'MFA is now enabled.');
                this.modalService.message(settings).then((e) => { this.init(); }).catch((e) => { });
            });
        }).catch(() => { });
    }

    async showManageMfa(): Promise<void> {
        const [smtpSender, smtpHost, smtpPort] = await Promise.all([
            this.configurationService.getEffectiveSettingValue('SmtpSender'),
            this.configurationService.getEffectiveSettingValue('SmtpHost'),
            this.configurationService.getEffectiveSettingValue('SmtpPort')
        ]);

        this.allowShowManageMfa = !!smtpSender && !!smtpHost && !!smtpPort;
    }

    disableMFA() {
        const settings = new ModalSettingsTemplate();
        this.modalService.openTemplate(this.disableMfaTemplate, settings).then(() => {
            this.loadingPanelService.showLoadingPanelDirect('Disabling MFA...');
            this.userService.clearSecret(this.clonedUser.UserId).then(result => {
                this.loadingPanelService.hideLoadingPanel();
                const settings = new ModalSettingsMessage('Multi Factor Authentication', 'MFA is now disabled.');
                this.modalService.message(settings).then((e) => { this.init(); }).catch((e) => { });
            });
        }).catch(() => { });
    }

    generateNewMfaSecret() {
        const settings = new ModalSettingsTemplate();
        this.modalService.openTemplate(this.regenerateSecretTemplate, settings).then(() => {
            this.loadingPanelService.showLoadingPanelDirect('Generating new secret...');
            this.userService.generateNewSecret(this.clonedUser.UserId).then(result => {
                this.loadingPanelService.hideLoadingPanel();
                const settings = new ModalSettingsMessage('Multi Factor Authentication', 'A new secret has been send to your email.');
                this.modalService.message(settings).then((e) => { this.init(); }).catch((e) => { });
            });
        }).catch(() => { });
    }

    resendMFASecret() {
        this.loadingPanelService.showLoadingPanelDirect('Resending MFA Secret...');
        this.userService.resendSecret(this.clonedUser.UserId).then(result => {
            this.loadingPanelService.hideLoadingPanel();
        });
    }
}

export class UserSavedArgs {
    constructor(public savedUser: User, public isNew: boolean) { }
}
